// @ts-nocheck

import React from 'react';

import useUuid from '../../../../hooks/useUuid';

type GRRulesSvgAsComponentProps = {
  className?: string;
  key?: string;
};

const GRRulesSvgAsComponent = ({ className, key }: GRRulesSvgAsComponentProps) => {
  const uuid = useUuid();
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const uniqueIdentifier = `${uuid}${key ? `__${key}` : ''}`;

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1450.7 334.3">
      <defs>
        <linearGradient
          id={`gr_rules_gradient-${uniqueIdentifier}`}
          gradientUnits="userSpaceOnUse"
          x1="1305.7976"
          y1="252.4489"
          x2="25.859"
          y2="93.2365"
        >
          <stop offset="0" stopColor="#FF0000" />
          <stop offset="1" stopColor="#8E0000" />
        </linearGradient>
      </defs>
      <g>
        <path
          fill={`url(#gr_rules_gradient-${uniqueIdentifier})`}
          d="M1205.2,27.7V0L0,6.4l29.3,327.2h1175.9v-30.4l155.4-171L1205.2,27.7z M1189.5,162l48.7-69.5l66,46.3
		l-48.7,69.5L1189.5,162z"
        />
        <path fill="#950000" d="M1189.5,162l48.9-51l65.8,27.8l-65.8-48.4L1189.5,162z" />
        <path
          fill="none"
          stroke="#FFE600"
          strokeWidth="15"
          d="M1382.5,85.5C1320.4,127.2,1237,164,1237,164s124.3,83.4,176.6,52.3S1444.7,43.8,1382.5,85.5L1382.5,85.5z"
        />
      </g>
      <path
        fill="#FB0000"
        d="M1255.6,208.3l40.5-57.7c0,0,32.7,16.5,32,16.5s-59.9,68.2-59.9,68.2l-9.9-27L1255.6,208.3z"
      />
      <path
        fill="#950000"
        d="M30.7,334.3l-5-21.4l1179.4,3.6v-12.9l155-170.7l7.1,7.1l-150.7,163.6v30.7L30.7,334.3L30.7,334.3z"
      />
    </svg>
  );
};

export default GRRulesSvgAsComponent;
